@use "../../../sass/variables/colors" as colors;
@use "../../../sass/mixins/font-family" as typography;
@use "../../../sass/mixins/nimbus" as nimbus;

@property --gradient-color1 {
    syntax: "<color>";
    initial-value: #{colors.$color-white};
    inherits: false;
}

@property --gradient-color2 {
    syntax: "<color>";
    initial-value: #{colors.$color-white};
    inherits: false;
}

ux-iws-nb-all-in-one-tile {
    --background-color: #{colors.$color-white};
    --heading-color: #{colors.$color-black-1};
    --text-color: #{colors.$color-black-1};
    --gradient-color1: #{colors.$color-white};
    --gradient-color2: #{colors.$color-white};
}

ux-iws-nb-all-in-one-tile {
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    position: relative;
    box-sizing: border-box;
    padding: 0;
    @include typography.font(light);
    background-color: var(--background-color);
    color: var(--text-color);
    width: 100%;
    min-height: 110px;
    cursor: pointer;
    overflow: hidden;

    &:not(:last-of-type) {
        border-bottom: 1px solid #747474;
    }

    * {
        box-sizing: border-box;
    }

    h2,
    h3,
    h4,
    h5 {
        @include nimbus.nb-heading(4, true);
        margin: 0;
        color: inherit;
    }

    p {
        @include typography.font(light);
        font-size: 16px;
        line-height: 1.2;
        margin: 0;
        color: inherit;
    }

    p:not(:last-of-type) {
        margin-bottom: 1em;
    }

    @media (min-width: 1024px) {
        min-height: 160px;
    }

    @media (max-width: 767px) {
        transition: background-color 0.3s ease-out;
    }
}

.ux-iws-nb-all-in-one-tile {
    &__image {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 25%;
        height: auto;
        overflow: hidden;
        opacity: 0;
        transform: translateX(40px);
        transition:
            opacity 0.3s ease-out,
            transform 0.3s ease-out;

        img {
            position: absolute;
            display: block;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        @media (max-width: 767px) {
            display: none;
        }
    }

    &__gradient {
        position: absolute;
        inset: 0;
        transition:
            --gradient-color1 0.3s ease-in-out,
            --gradient-color2 0.3s ease-in-out;
        background: linear-gradient(
            90deg,
            var(--gradient-color1) 25%,
            var(--gradient-color2) 75%
        );

        @media (max-width: 767px) {
            display: none;
        }
    }

    &__inner {
        position: relative;
        padding: 30px;
        margin: 0;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
    }

    &__content {
        flex: 1 1 auto;
        position: relative;
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }

    &__title {
        @include typography.font(bold);
        font-size: 20px;
        line-height: 1.2;
        margin: 0 0 1rem;
        max-width: 400px;
    }

    &__text {
        @include typography.font(light);
        font-size: 1rem;
        line-height: 1.2;
        flex: 1 0 auto;
        max-width: 400px;
    }

    &__icon {
        flex: 0 0 auto;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;
        width: 60px;
        padding-right: 30px;
    }

    ux-icon {
        font-size: 24px;
        transform-origin: center;
        transition: transform 0.3s ease-out;
    }
}

ux-iws-nb-all-in-one-tile:hover {
    --background-color: #{colors.$color-blue-headline};
    --heading-color: #{colors.$color-white};
    --text-color: #{colors.$color-white};
    --ux-button-focus-border-color: #{colors.$color-white};

    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    .ux-iws-nb-all-in-one-tile__image {
        opacity: 1;
        transform: none;
    }

    .ux-iws-nb-all-in-one-tile__gradient {
        --gradient-color1: #{colors.$color-blue-headline};
        --gradient-color2: #{colors.$color-white};

        opacity: 1;
    }

    ux-icon {
        transform: rotate(90deg);
    }
}

ux-iws-nb-all-in-one-tile:active,
ux-iws-nb-all-in-one-tile[active] {
    --background-color: #{colors.$color-blue-headline};
    --heading-color: #{colors.$color-white};
    --text-color: #{colors.$color-white};

    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    .ux-iws-nb-all-in-one-tile__image {
        opacity: 0;
        transform: none;
    }

    .ux-iws-nb-all-in-one-tile__gradient {
        --gradient-color1: #{colors.$color-blue-headline};
        --gradient-color2: #{colors.$color-blue-headline};

        opacity: 1;
    }

    ux-icon {
        transform: rotate(135deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    ux-iws-nb-all-in-one-tile ux-icon {
        transition: none;
    }
}
